import React from 'react';
/**
 * A simple divider with color option
 */
export default function Divider(_a) {
    var color = _a.color;
    return (React.createElement("div", { className: "madonna-divider", style: { borderBottom: "1px solid " + color } }));
}
//# sourceMappingURL=Divider.js.map